const validate = values => {
  const errors = {}

  if (!values?.currentPwd) {
    errors.currentPwd = "The current password is required"
  }

  if (!values?.newPwd) {
    errors.newPwd = "The new password is required"
  }

  if (
    values?.newPwd &&
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/.test(
      values.newPwd
    )
  ) {
    errors.newPwd =
      "The password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number and one special character"
  }

  if (values?.newPwd !== values?.newPwd2) {
    errors.newPwd2 = "The passwords don't match"
  }

  return errors
}

export default validate
